import { generatePath, NavLink } from 'react-router-dom';
import clsx from 'clsx';
import styles from './menu-app.module.scss';
import { MenuData, menuData } from './menu-data';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router';
import { useGetLikeMe } from '@/hooks/use-get-like-me';
import { routesApp } from '@/constans/routes';
import WebApp from '@twa-dev/sdk';
import { profilesApi } from '@/api';
import { useVibration } from '@/store/useVibration';
import { useAuth } from '@/store/useAuth';
import { PROFILE_CHANNEL_RECEIVED } from '@/utils/events';

interface Props {
    className?: string;
}

interface IItemsCount {
    [key: string]: {
        count: number,
        type: 'counter' | 'dot'
    };
}

export const MenuApp: React.FC<Props> = ({ className }) => {
    const { data, error } = useGetLikeMe();
    const [itemsCount, setItemsCount] = useState<IItemsCount>({});
    const navigate = useNavigate();

    const { setProfile } = useAuth((state) => state);

    const onProfileChannelReceived = (data: CustomEventInit) => {
        const payload = data.detail
        switch (payload.type) {
            case 'message_created':
                setItemsCount(
                    (prev) => ({
                        ...prev,
                        messages: {
                            count: payload.data.chats_unread_count,
                            type: 'counter'
                        }
                    })
                );

                break;
            case 'chat_created':
                setItemsCount(
                    (prev) => ({
                        ...prev,
                        messages: {
                            count: payload.data.chats_unread_count,
                            type: 'counter'
                        }
                    })
                );

                break;
            case 'moderation_status_changed':
                setProfile({
                    ...payload.data.profile
                })
                break;
        }
    }
    
    useEffect(() => {
        (async () => {
            try {
                let data = await profilesApi.getChats(1);

                if (data.data.data) {
                    setItemsCount(
                        (prev) => ({
                            ...prev,
                            messages: {
                                count: data.data.data.filter(item => item.unread_count > 0).length,
                                type: 'counter'
                            }
                        })
                    );
                }
            } catch (e) {
                console.error('Chats api error', e)
            }
        })()

        window.addEventListener(PROFILE_CHANNEL_RECEIVED, onProfileChannelReceived)

        return () => {
            window.removeEventListener(PROFILE_CHANNEL_RECEIVED, onProfileChannelReceived)
        };
    }, []);


    useEffect(() => {
        if (error) {
            const axiosError = error as any;
            if (axiosError.response?.status === 403 && axiosError.response?.data?.is_banned) {
                navigate(routesApp.banned);
            }
        }

        if (data)
            setItemsCount(
                (prev) => ({
                    ...prev,
                    liked: {
                        count: [
                            ...data.data.paid,
                            ...data.data.free
                        ].length,
                        type: 'counter'
                    },
                })
            );
    }, [data, error]);

    const { isVibrationEnabled } =
        useVibration(state => state);
    
    const handleMenuClick = (link: string) => {
        navigate(generatePath(link));
        if (isVibrationEnabled) {
            WebApp
                .HapticFeedback
                .impactOccurred('medium');
            // pass for not android
            navigator.vibrate?.(10)
        }
    };

    const isShowTabNotificationIcon = (item: MenuData) => {
        if (
            Object
                .keys(itemsCount)
                .includes(item.value)
        )
            return itemsCount[
                item.value
            ]
                .count > 0
        return false
    }

    return (
        <nav id="app-layout-menu" className={clsx(className, styles.menu)}>
            <ul className={styles.list}>
                {menuData.map((item) => {
                    const IconComponent = item.icon;
                    return (
                        <li
                            key={item.title}
                            className={styles.item}
                            onClick={() => handleMenuClick(item.path)}>
                            <NavLink
                                to={item.path}
                                className={
                                    ({ isActive }) =>
                                        isActive ?
                                            styles.link + ' ' + styles.active
                                        :
                                            styles.link
                                }>
                                <IconComponent />
                                {isShowTabNotificationIcon(item) && (
                                    itemsCount[item.value].type === 'counter' ?
                                        <div className={styles.counter}>
                                            {
                                                itemsCount[item.value].count >= 100 ?
                                                    99
                                                :
                                                    itemsCount[item.value].count
                                            }
                                        </div>
                                    :
                                        <div className={styles.notificationDot} />
                                )}
                            </NavLink>
                        </li>
                    );
                })}
            </ul>
        </nav>
    );
};
